// extracted by mini-css-extract-plugin
module.exports = {"background":"_88527b44","wrapper":"_997fc99","header":"_35644275 _c3c0b971","button":"_c8a2951c"};